export default {
  // 平台业务
  PAGE_BUSSINESS_FARMER_PHOTO_REVIEW: "farmerPhotoReview", // 农户照片审核

  //系统基础
  PAGE_HOME_INDEX: "home_index", //首页
  PAGE_LOGIN: "login", //登录页
  PAGE_LOCKING: "locking", //锁屏页
  PAGE_ACCESS_INDEX: "access_index", //权限页
  PAGE_ORGAN_INDEX: "organ_index", //机构结构页面
  PAGE_ROLE_INDEX: "role_index", //角色管理页面
  PAGE_USER_INDEX: "user_index", //用户管理页面
  PAGE_USER_ADD: "user_add", //新增用户
  PAGE_USER_UPDATE: "user_update", //修改用户
  PAGE_PERMISSION_INDEX: "permission_index", //权限管理页面
  PAGE_APP_INDEX: "app_index", //APP版本管理页面
  PAGE_RN_INDEX: "rn_index", //RN版本管理页面
  PAGE_DICTTYPE: "dictType", //字典管理页面
  PAGE_DICTDATA: "dictData", //字典数据页面
  PAGE_SYS_CONFIG: "sysConfig", //参数配置页面
  PAGE_SYSTEM_BANNER_INDEX: "bannerIndex", //官网轮播图管理页面
  PAGE_SYSTEM_BANNER_ADD: "bannerAdd", //官网轮播图添加页面
  PAGE_SYSTEM_BANNER_UPDATE: "bannerUpdate", //官网轮播图修改页面

  //模板
  PAGE_SYS_ROLE: "SysRole", //角色管理
  PAGE_SYS_USER: "SysUser", //用户管理
  PAGE_SYS_USER_ADD: "SysUserAdd", //新增用户
  PAGE_SYS_USER_UPDATE: "SysUserUpdate", //修改用户
  PAGE_BUSINESS_PHOTOEXAMINE: "BusinessPhotoExamine", //照片审核
  PAGE_BUSINESS_APPOINTMENTRECOVERY: "BusinessAppointmentRecovery", //可回收预约
  PAGE_BUSINESS_APPOINTMENTRECOVERYVILLAGE:
    "BusinessAppointmentRecoveryVillage", //管辖村级详情
  PAGE_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL:
    "BusinessAppointmentRecoveryUserDetail", //可回收预约-管辖用户详情
  PAGE_BUSINESS_FAMILYAPPIONTMENT: "BusinessFamilyAppiontment", //家宴预约城镇
  PAGE_BUSINESS_FAMILYVILLAGE: "BusinessFamilyVallage", //家宴预约乡村
  PAGE_BUSINESS_FAMILYDETAIL: "BusinessFamilyDetail", //家宴预约
  PAGE_BUSINESS_AUDITOR: "BusinessAuditor", //审核员工作
  PAGE_BUSINESS_INSPECTOR: "BusinessInspector", //督查员工作
  PAGE_BUSINESS_INSPECTORDETAIL: "BusinessInspectorDetail", //督查员工作详情
  PAGE_BUSINESS_INSPECTORDETAILLIST: "BusinessInspectorDetailList", //督查员工作详情列表
  PAGE_BUSINESS_INSPECTORDETAIL_IMG: "BusinessInspectorDetailImg", //督查员详情图片
  PAGE_BUSINESS_INSPECTORMONTH_EXPORT: "BusinessInspectorMonthExport", //督查员督查次数按周导出
  PAGE_BUSINESS_COLLECTOR: "BusinessCollector", //s收集员
  PAGE_BUSINESS_COLLRCTORDETAIL: "BusinessCollectorDetail", //收集员详情
  PAGE_BUSINESS_COLLRCTORDETAIL_IMG: "BusinessCollectorDetailImg", //收集员详情图片
  PAGE_BUSINESS_SECRETINSPECTION: "BusinessSecretInspection", //暗访督查
  PAGE_BUSINESS_PAVILIONTOWN: "BusinessPavilionTown", //亭长签到--镇
  PAGE_BUSINESS_PAVILIONVVILLAGE: "BusinessPavilionVillage", //亭长签到--乡村
  PAGE_BUSINESS_PAVILIONSPOT: "BusinessPavilionSpot", //亭长签到--点
  PAGE_BUSINESS_PAVILIONTOWN_SIGNIN: "BusinessPavilionSignIn", //亭长签到--签到日历
  PAGE_BUSINESS_PAVILION_MAP: "BusinessPavilionMap", //亭长签到--签到定位
  PAGE_BUSINESS_GARBAGEROOM: "BusinessGarbageRoom", //垃圾房管理
  PAGE_BUSINESS_GARBAGEROOM_VILLAGE: "BusinessGarbageRoomVillage", //所属垃圾站
  PAGE_BUSINESS_GARBAGEROOM_MONTH: "BusinessGarbageRoomMonth", //垃圾房管理--按月查询
  PAGE_BUSINESS_GARBAGEROOM_CALENDAR: "BusinessGarbageRoomCalendar", //垃圾房日历
  PAGE_BUSINESS_GARBAGEROOM_MAP: "BusinessGarbageRoomMap", //垃圾房地图
  PAGE_BUSINESS_PERISHABLESTATION: "BusinessPerishableStation", //易腐处理站
  PAGE_BUSINESS_TOWNGARBAGESTATISTIC: "BusinessTownGarbageStatistic", //易腐垃圾镇统计
  PAGE_BUSINESS_PERISHABLESTATION_MATERIAL: "BusinessPerishableStationMaterial", //入料
  PAGE_BUSINESS_MATERIALDETAIL: "BusinessMaterialDetail", //入料
  PAGE_BUSINESS_GARBAGETOTAL: "BusinessGarbageTotal", //垃圾汇总
  PAGE_BUSINESS_GARBAGETOTAL_OTHER: "BusinessGarbageTotalOther", //垃圾汇总--其他垃圾
  PAGE_BUSINESS_GARBAGETOTAL_HARM: "BusinessGarbageTotalHarm", //垃圾汇总--有害垃圾
  PAGE_BUSINESS_GARBAGETOTAL_BIG: "BusinessGarbageTotalBig", //垃圾汇总--大件垃圾
  PAGE_BUSINESS_RECYCLABLE: "BusinessRecycable", //垃圾汇总--可回收垃圾--乡镇
  PAGE_BUSINESS_RECYCLABLEDETAIL: "BusinessRecycableDetail", //垃圾汇总--可回收垃圾--详情
  PAGE_BUSINESS_RECYCLABLEDETAIL_INFO: "BusinessRecycableDetailInfo", //垃圾汇总--可回收垃圾--个人
  PAGE_BUSINESS_SELFHELPRECOVERY: "BusinessSelfHelpRecovery", //自助回收审核
  PAGE_BUSINESS_RANK_INFO: "BusinessRankInfo", //排名信息
  PAGE_TRADEMANAGE_TRADEFLOW: "TradeManageTradeFlow", //交易流水
  PAGE_TRADEMANAGE_ACCOUNTINFO: "TradeManageAccountInfo", //账户信息
  PAGE_TRADEMANAGE_ACCOUNTFLOW: "TradeManageAccountFlow", //账户流水
  PAGE_TRADEMANAGE_INTEGRALTOTAL: "TradeManageIntegralTotal", //用户积分余额汇总
  PAGE_TRADEMANAGE_INTEGRALEXCHANGE: "TradeManageIntegralExchange", //积分兑换统计
  PAGE_TRADEMANAGE_INTEGRALEXCHANGE_VILLAGE:
    "TradeManageIntegralExchangeVillage", //镇级统计
  PAGE_TRADEMANAGE_INTEGRALEXCHANGE_IN: "TradeManageIntegralExchangeIn", //兑换中订单
  PAGE_TRADEMANAGE_EXCHANGEDETAIL: "TradeManageExchangeDetail", //订单明细
  PAGE_BASICDATA_STARSPLANMANAGE: "BasicDataStarsPlanManage", //评星计划管理
  PAGE_TRADEMANAGE_BANKCARDMANAGE: "TradeManageBankCardManage", //银行卡管理
  PAGE_BASICDATA_DICTIONARY: "BasicDataDictionary", //数据字典
  PAGE_BASICDATA_REDBAGCASECONFIG: "BasicDataRedBagCaseConfig", //红包活动配置
  PAGE_BASICDATA_STARTYPEMANAGE: "BasicDataStarTypeManage", //评星项管理
  PAGE_BASICDATA_SECTORALLOCATION: "BasicDataSectorAllocation", //行业配置管理
  PAGE_BASICDATA_BONUSPOINTS: "BasicDataBonusPoints", //奖励积分
  PAGE_BASICDATA_WORKCONTACT: "BasicDataWorkContact", //工作人员联系表
  PAGE_BUSINESS_GARBAGEBAGMANAGE: "BusinessGarbageBagManage", //垃圾袋管理
  PAGE_BUSINESS_GARBAGEBAGMANAGE_VILLAGE: "BusinessGarbageBagManageVillage", //垃圾袋管理--村
  PAGE_BUSINESS_GARBAGEBAGMANAGE_AREA: "BusinessGarbageBagManageArea", //垃圾袋管理--区
  PAGE_BUSINESS_GARBAGEBAGMANAGE_AREADETAIL:
    "BusinessGarbageBagManageAreaDetail", //垃圾袋管理--区详情
  PAGE_BUSINESS_GARBAGEBAGCOUNT: "BusinessGarbageBagCount", //垃圾袋入库统计
  PAGE_SYSTEM_MERCHANTS: "SystemMerchants", //商户管理
  PAGE_BASICDATA_PROPAGATEIMG: "BasicdataPropagateImg", //宣传图
  PAGE_BASICDATA_RECOVERYPRICE: "BasicdataRecoveryPrice", //回收价格
  PAGE_BASICDATA_PAYMENTSCORECONFIG: "BasicDataPaymentScoreConfig", //用户缴费积分配置
  PAGE_BASICDATA_GOODSMANAGE: "BasicDataGoodsManage", //商品管理
  PAGE_BASICDATA_RECYCLESITE: "BasicDataRecycleSite", //回收站点管理
  PAGE_BASICDATA_RECYCLESITE_MAP: "BasicDataRecycleSiteMap", //回收站点管理--定位
  PAGE_BASICDATA_SITE_MAP: "BasicDataSiteMap", //回收站点管理--定位
  PAGE_BASICDATA_ROTGARBAGECAPACITY: "BasicDataRotGarbageCapacity", //易腐垃圾回收设备
  PAGE_BASICDATA_ORGANRELATE: "BasicDataOrganRelate", //自查机构管理
  PAGE_BASICDATA_PURCHASEACTIVITIES: "BasicDataPurchaseActivities", //活动配置
  PAGE_SYSTEM_CHANNELAUTHCODE: "SystemChannelAuthCode", //授权码管理
  PAGE_BUSINESS_DELIVERY: "BusinessDelivery", //定时定点投放小区
  PAGE_BUSINESS_DELIVERYVILLAGE: "BusinessDeliveryVillage", //定时定点投放小区统计
  PAGE_BUSINESS_DELIVERYVILLAGE_DETAIL: "BusinessDeliveryVillageDetail", //定时定点投放小区统计详情
  PAGE_BUSINESS_EQUIPMENTSTATISTICS: "BusinessEquipmentStatistics", //设备自查统计
  PAGE_BUSINESS_EQUIPMENTSTATISTICS_DETAIL: "BusinessEquipmentStatisticsDetail", //设备自查统计详情
  PAGE_BUSINESS_EQUIPMENTSTATISTICS_IMG: "BusinessEquipmentStatisticsImg", //设备自查统计附件
  PAGE_TRADEMANAGE_COMPENSATE: "TradeManageCompensate", //商户积分补偿
  PAGE_TRADEMANAGE_COMPENSATE_DETAIL: "TradeManageCompensateDetail", //商户积分补偿详情
  PAGE_TRADEMANAGE_WITHDRAWAL: "TradeManageWithdrawal", //商户提现
  PAGE_SYSTEM_ORGAN: "SystemOrgan", //机构管理
  PAGE_BASICDATA_NEWS: "BasicDataNews", //新闻管理
  PAGE_BASICDATA_NEWS_ADD: "BasicDataNewsAdd", //新增新闻
  PAGE_BASICDATA_NEWS_UPDATE: "BasicDataNewsUpdate", //修改新闻
  PAGE_BASICDATA_QUESTIONMANAGE: "BasicDataQuestionManage", //考题管理
  PAGE_BASICDATA_QUESTIONMANAGE_ADD: "BasicDataQuestionManageAdd", //新增考题
  PAGE_BASICDATA_QUESTIONMANAGE_UPDATE: "BasicDataQuestionManageUpdate", //修改考题
  PAGE_SYSTEM_BSSYSCONFIG: "SystemBsSysConfig", //系统配置
  PAGE_BUSINESS_SUPERVISORPUNCHLCLOCK: "BusinessSupervisorPunchClock", //督导员打卡统计
  PAGE_BUSINESS_SUPERVISORPUNCHLCLOCKDETAIL: "SupervisorPunchClockDetail", //督导员打卡统计详情
  PAGE_BUSINESS_INSPECTORPUNCHCLOCK: "BusinessInspectorPunchClock", //巡查员打卡统计
  PAGE_BUSINESS_INSPECTORPUNCHCLOCKSTATICDETAIL:"BusinessInspectorPunchClockStaticDetail", //巡查员打卡统计详情
  PAGE_BUSINESS_INSPECTORPUNCHCLOCKDETAIL: "BusinessInspectorPunchClockDetail", //巡查员打卡详情
  PAGE_BUSINESS_PICKUPSTAFFPUNCHCLOCK: "BusinessPickupStaffPunchClock", //清运人员打卡统计
  PAGE_BUSINESS_PICKUPSTAFFPUNCHCLOCKDETAIL:"BusinessPickupStaffPunchClockDetail", //清运人员打卡详情统计
  PAGE_BUSINESS_TOWN_GARBAGETOTAL: "BusinessTownGarbageTotal", //镇垃圾汇总
  PAGE_BUSINESS_VILLAGE_GARBAGETOTAL: "BusinessVillageGarbageTotal", //村垃圾汇总
  PAGE_BUSINESS_GARBAGETOTAL_DETAIL: "BusinessGarbageTotalDetail", //垃圾汇总详情
  PAGE_BUSINESS_REDHEIBANG: "RedHeiBang", //红黑榜
  PAGE_BUSINESS_DEVICEPUNCHCLOCK:'BusinessDevicePunchClock',//设备打卡统计
  PAGE_BUSINESS_PUNCHCLOCKDETAIL:'BusinessPunchClockDetail',//设备打卡
  PAGE_BUSINESS_PUBLICENVIROMENTCHECK: "PublicEnviromentCheck", //公共环境检查统计
  PAGE_BUSINESS_PUBLICENVIROMENTCHECKDETAIL: "PublicEnviromentCheckDetail", //公共环境检查详情
  PAGE_BUSINESS_PUBLICENVIROMENTCHECK_MAP: "PublicEnviromentCheckMap", //公共环境检查详细信息
};



// WEBPACK FOOTER //
// ./src/constant/PageName.js